export const PLACEHOLDER = '-';
export const DEFAULT_PAGE_SIZE = 3000;
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_MASK_FORMAT = { format: 'DD.MM.YYYY', type: 'mask' } as const;
export const DEFAULT_IMAGE =
  'https://ws.adriagate.com/TRWS-IMG/ImagesService.svc/Image/ST-LOCAL-ADRIAGATE-TEST/4664946-13/3_300_300.jpg';
